import { combineLatest, map, Observable } from 'rxjs';
import {
  ChangeDetectorRef,
  inject,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { PermissionsService } from './permissions.service';

import { PERM, Permission } from '@iss/libs/permissions';
import { Maybe } from '@iss/libs/graphql';

@Pipe({ name: 'ifHasPermission', pure: false, standalone: true })
export class IfHasPermissionPipe implements PipeTransform, OnDestroy {
  private readonly service = inject(PermissionsService);
  private readonly asyncPipe = new AsyncPipe(inject(ChangeDetectorRef));
  private enabled = true;
  private permissions: readonly Permission[] | undefined;
  private permission$: Observable<boolean> | undefined;

  public transform(enabled: Maybe<unknown>, ...permissions: readonly Permission[]): boolean {
    const effectiveEnabled = Boolean(enabled);
    if (effectiveEnabled !== this.enabled || permissions !== this.permissions) {
      this.enabled = effectiveEnabled;
      this.permissions = permissions;
      this.permission$ = combineLatest(permissions.map(permission => this.service.isSufficient(PERM[permission]))).pipe(
        map(result => result.some(Boolean)),
      );
    }

    return this.enabled && (this.asyncPipe.transform(this.permission$) ?? false);
  }

  public ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }
}
